import type { Page } from '../../types';
import { COUNTRIES } from '../../defaultContent';

const addPreventedError: Page[] = [
  {
    pageType: 'question',
    title: 'Future loss prevented (error)',
    name: 'prevented-error-declare-page',
    description:
      'The future loss prevented fraud and error section refers to calculated savings that evidence that fraud or error would have continued for a period of time had it not been detected, and would subsequently have resulted in a financial loss. These calculated savings should be based on evidenced and agreed assumptions.<br><br>' +
      'Only methodologies approved by the Prevention Panel can be used for calculating Future Loss Prevented savings.<br><br>' +
      'The Prevention Panel, facilitated by the PSFA, reviews and approves methodologies for claiming prevented savings.<br><br>' +
      'The Methodology Bank contains all approved methodologies and their conditions of use.<br><br>' +
      'For access to the Methodology Bank or further information, email psfa.performance@cabinetoffice.gov.uk.',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of Future loss prevented (error) to declare?',
        name: 'prevented_future_error_declare',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
    ],
  },
  {
    pageType: 'list',
    title: 'Add an instance of future prevented error',
    name: 'prevented-error-add-instance',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'prevented_future_error_impact' },
        { title: 'Total Value', field: 'prevented_future_error' },
      ],
    },
    description:
      'All entries should refer to errors that were prevented specifically because of a counter fraud activity. A counter fraud activity is an effort where the counter fraud resource has either:' +
      '<ul><li>Carried out an exercise or investigation, or</li><li>Influenced an activity or process, leading to a tangible improvement or prevention</li></ul><br/>' +
      'Examples of counter fraud activities are a fraud investigation, proactive detection methods, such as data analytics or matching aimed at finding fraud or compliance checks performed by counter fraud resource.<br><br>' +
      'A counter fraud influenced activity or process is when the counter fraud team influences a change, such as suggesting new controls or policies. For example, after a fraud risk assessment, the team recommends that operational staff gather more evidence during compliance checks.',
    disabled: [
      {
        field: 'prevented_future_error_declare',
        condition: 'equals', // optional
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'select',
        title: 'Which spending area was the error prevented in?',
        name: 'prevented_future_error_area',
        detailsHeading: 'Help with spending areas',
        detailsContent:
          ' <b>Benefits:</b> money given by the government to support members of the public' +
          ' <br/><b>Charges & other non-tax income:</b> money owed to public sector organisations (for example, court fines or prescription fees)' +
          ' <br/><b>Grants:</b> money given by a public sector organisation for a specific purpose' +
          ' <br/><b>Licences & permits:</b> licences, permits or certificates that grant permissions (for example, a Blue Badge, Surveyor licence, marriage certificate)' +
          ' <br/><b>Loans & credit guarantees:</b> money loaned or guaranteed by a public sector organisation' +
          ' <br/><b>Personnel:</b> employees (including contractors and agency workers)' +
          ' <br/><b>Procurement:</b> goods or services bought by public sector organisations (including suppliers)' +
          ' <br/><b>Special payments:</b> money given in unique or specific circumstances (for example, compensation)' +
          ' <br/><b>Subsidies:</b> support or incentives given by the government' +
          ' <br/><b>Tax and duties:</b> mandatory government charge for goods, income or services',
        options: [
          'Benefits',
          'Charges & other non-tax income',
          'Grants',
          'Licences & permits',
          'Loans & credit guarantees',
          'Personnel',
          'Procurement',
          'Special payments',
          'Subsidies',
          'Tax and duties',
        ],
        hintOption: 'Please Select',
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title: 'Who was responsible for the error?',
        name: 'prevented_future_error_responsible',
        detailsHeading: 'Who was responsible for the error?',
        hint: 'who was responsible for the unintentional mistake (error)?',
        detailsContent:
          'Use these options to identify who was responsible for the fraud or error.<br/><br/>' +
          '<b>Customer:</b> a member of the public or someone acting on behalf of a business or charity' +
          '<br/><b>Official:</b> a government department, public body or service' +
          '<br/><b>Supplier:</b> a person or business contracted to supply a service' +
          '<br/><b>Unknown:</b> I do not know who was responsible for the fraud or error',
        options: ['Customer', 'Official', 'Supplier', 'Unknown'],
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title: 'Counter fraud involvement?',
        name: 'prevented_future_error_involved',
        detailsHeading: 'Help with counter fraud involvement',
        detailsContent:
          'Use these options to describe how the counter fraud resource contributed to preventing fraud or error.<br/><br/>' +
          '<b>Counter fraud delivered:</b> the counter fraud resource carried out the prevention activity relating to the fraud or error' +
          '<br/><b>Counter fraud influenced:</b> the counter fraud resource influenced the prevention activity relating to the fraud or error',
        options: ['Counter fraud delivered', 'Counter fraud influenced'],
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title: 'Is this related to Covid 19 activity?',
        name: 'prevented_future_error_c19',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
      {
        questionType: 'instanceInput',
        title: 'How many instances were prevented?',
        name: 'prevented_future_error_impact',
        txt: `Total number of instances.`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'What was the value of the prevented error?',
        name: 'prevented_future_error',
        txt: `Total value`,
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textInput',
        title: 'Enter the methodology number here',
        name: 'prevented_future_error_methodology_number',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'prevented_future_error_comments',
        hint: `Please ensure you do not include any personal or sensitive information`,
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default addPreventedError;
